import { appSettings } from "../AppSettings";
import apiClient from "./ApiClient";

class NetworkMonitor {

    protected _lastNetCheckTime: number;
    protected _isOffline: boolean = false;


    async checkNetworkAsync(force = false) {

        const mustCheck = !this._lastNetCheckTime || new Date().getTime() - this._lastNetCheckTime > appSettings.onlineCheckInterval || force;

        if (mustCheck) {
            try {
                await apiClient.pingAsync()
                this._isOffline = false;
            }
            catch {
                this._isOffline = true;
            }
            this._lastNetCheckTime = new Date().getTime();
        }

        return !appSettings.offlineMode || !this._isOffline;
    }

   get isOffline() { return this._isOffline; }
}


export const networkMonitor = new NetworkMonitor();